/**
 * The rich-text editor as a separate chunk (TipTap + ProseMirror ≈ 130 KB gzip, see
 * docs/research/ui/rich-text-editor.md): loaded the first time a composer opens, not with the app.
 */
import { lazy, Suspense } from 'react';
import { Skeleton } from '../components/misc';
import { cn } from '../lib/utils';
import type { RichTextEditorProps } from './rich-text-editor';

const RichTextEditor = lazy(() => import('./rich-text-editor').then((module) => ({ default: module.RichTextEditor })));

export function LazyRichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense fallback={<Skeleton aria-busy="true" className={cn('rounded-md', props.className)} />}>
      <RichTextEditor {...props} />
    </Suspense>
  );
}
